module.exports = __webpack_public_path__ + "static/media/storage.a262c93a.png";